'use client'

import CloseIcon from '@mui/icons-material/Close'
import {
  Box,
  Drawer,
  Toolbar,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useFormContext } from '../../../context/form'
import { useDrawerStore } from '../../../store/useDrawerStore'
import MortgageDetails from '../../form/MortgageDetails'
import MortgageFilters from '../../form/MortgageFilter'

import './DashboardDrawer.scss'

export const drawerWidth = 330

interface FormItem {
  label: string
  value: string
}

const defaultMortgageTypes = [
  {
    label: 'Fixed',
    value: 'Fixed',
  },
  {
    label: 'Variable',
    value: 'Variable',
  },
  {
    label: 'Tracker',
    value: 'Tracker',
  },
  {
    label: 'Discount',
    value: 'Discount',
  },
]

export default function DashboardDrawer() {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const { isDrawerOpen, handleDrawerClose, setDrawerToggle } = useDrawerStore()
  const { productsList, isFetchingProducts, isFetchingLenders, form } =
    useFormContext()
  const theme: any = useTheme()
  const isMatchDownMd = useMediaQuery(theme.breakpoints.down('md'))

  const [mortgageTypes, setMortgageTypes] =
    useState<FormItem[]>(defaultMortgageTypes)

  const DrawerContent = (
    <>
      <Toolbar
        sx={{
          // position: 'relative',
          backgroundColor: 'primary.main',
          display: 'flex',
          alignItems: 'center',
          px: [1],
        }}
      >
        <div onClick={handleDrawerClose} className="btn-drawer-close">
          <CloseIcon sx={{ color: 'white' }} />
        </div>
      </Toolbar>
      <Box className="sidebar-content">
        <Box className="sidebar-content-inner">
          <MortgageDetails />
          <MortgageFilters mortgageTypes={mortgageTypes} />
        </Box>
      </Box>
    </>
  )

  useEffect(() => {
    if (theme?.custom?.apiKey) {
      // GoDirect
      // if (theme.custom.apiKey === '60f020d0-aa94-4c03-a945-268924f85b4a') {
      // }
      setMortgageTypes((types) => [...defaultMortgageTypes])
      switch ('Yes') {
        case theme.custom.appConfig.isOffset:
          form.setValue('others', 'Offset')
          break
        case theme.custom.appConfig.flexible:
          form.setValue('others', 'Flexible (No ERC)')
          break
        case theme.custom.appConfig.helpToBuy:
          form.setValue('others', 'Help to Buy')
          break
        case theme.custom.appConfig.firstTimeBuyer:
          form.setValue('others', 'First Time Buyer')
          break
        case theme.custom.appConfig.buyToLetHMO:
          form.setValue('businessType', 'Buy_To_Let Purchase')
          form.setValue('buildingUse', 'HMO')
          break
        case theme.custom.appConfig.limitedCompany:
          form.setValue('businessType', 'Buy_To_Let Purchase')
          form.setValue('buildingUse', 'Ltd Company')
          break
        case theme.custom.appConfig.adverseCredit:
          form.setValue('businessType', 'Bad_Credit Purchase')
          form.setValue('creditQuestions', ['CCJs', 'Arrears'])
          break
        case theme.custom.appConfig.adverseCreditRemortgage:
          form.setValue('businessType', 'Bad_Credit Remortgage')
          form.setValue('creditQuestions', ['CCJs', 'Arrears'])
          break
        case theme.custom.appConfig.newBuild:
          form.setValue('others', 'New Build')
          break
        case theme.custom.appConfig.cashback:
          form.setValue('cashback', 'Cashback')
          break
      }
    }
  }, [theme?.custom?.apiKey])

  useEffect(() => {
    if (isMatchDownMd) {
      handleDrawerClose()
    } else {
      setTimeout(() => {
        setDrawerToggle()
      }, 100)
    }
  }, [isMatchDownMd])

  useEffect(() => {
    setDrawerOpen(isDrawerOpen)
  }, [isDrawerOpen])

  return (
    <>
      <Drawer
        variant={isMatchDownMd ? 'temporary' : 'persistent'}
        open={drawerOpen}
        ModalProps={{
          container: document.getElementById('mp-best-buy-mortgage-form'),
          style: {
            left: 0,
            top: 0,
          },
          disableAutoFocus: true,
          disableEnforceFocus: true,
        }}
        onClose={() => handleDrawerClose()}
        sx={{
          zIndex: 2,
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: isMatchDownMd ? '80%' : drawerWidth,
            position: 'absolute',
            height: '100%',
            top: 0,
            overflow: 'hidden',
            maxWidth: '330px',
          },
        }}
      >
        <Box
          sx={{
            height: '100%',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {DrawerContent}
        </Box>
      </Drawer>
      {/* <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', md: 'block' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            borderWidth: 0,
          },
        }}
        open
      >
        <Box sx={{ overflow: 'auto' }}>{DrawerContent}</Box>
      </Drawer> */}
    </>
  )
}
